"use client";

import { ExpertiseCityStringSet } from "@/lib/strings/expertiseCityStrings";
import { Notary } from "@/lib/strings/notaries/notaryStringsPfalz";
import { SLCardWithImage } from "../cards/SLCardWithImage";
import { SLSectionCardsSlider } from "./SLSectionCardsSlider";

export function SLSectionNotariesSlider({
  expertiseCity,
  expertiseHubTitle,
}: {
  expertiseCity: ExpertiseCityStringSet;
  expertiseHubTitle: string;
}) {
  return (
    <SLSectionCardsSlider
      title={`Notare in ${expertiseCity.city}`}
      subtitle={
        expertiseCity.notariesDescription ?? `im Bereich ${expertiseHubTitle}`
      }
      items={expertiseCity.notaries || []}
      renderCard={(notary: Notary) => (
        <SLCardWithImage
          title={notary.name}
          subtitle={notary.address}
          description={notary.description ?? ""}
          imageUrl={notary.image ?? ""}
          url={notary.website}
        />
      )}
      getItemKey={(notary: Notary) => notary.name}
    />
  );
}
